import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

import { IrisButtonModule } from '@sondermind/iris/button';

import { FAQAccordionComponent } from './components/faq-accordion.component';

@NgModule({
  declarations: [FAQAccordionComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatExpansionModule,
    RouterModule,
    IrisButtonModule
  ],
  exports: [
    FAQAccordionComponent
  ]
})
export class FAQAccordionModule { }
